import type { MetricDim } from "@csbi/contracts"
import type { MetricDefinition } from "./types.js"

export type TableGroup = {
  metrics: MetricDefinition[]
  /** What one row is. Attribute metrics must be split by all of these, so this is also the tile's `splitBy` */
  dims: readonly MetricDim[]
  sensitive: boolean
}

/**
 * ⚠ **Sensitivity is part of the key, so a sensitive metric is never merged with an ordinary one.**
 */
const keyOf = (m: MetricDefinition) => `${m.domain}|${[...m.dims].sort().join(",")}|${m.sensitive ? "s" : ""}`

const RANK: Record<string, number> = { text: 0, timestamp: 1 }
const rank = (m: MetricDefinition) => RANK[m.valueType] ?? 2

export function groupTableMetrics(metrics: readonly MetricDefinition[]): TableGroup[] {
  const byKey = new Map<string, MetricDefinition[]>()

  for (const m of metrics) {
    if (m.defaultWidget !== "table") continue
    const key = keyOf(m)
    const bucket = byKey.get(key)
    if (bucket) bucket.push(m)
    else byKey.set(key, [m])
  }

  return [...byKey.values()].map((group) => {
    const ordered = group.map((m, i) => ({ m, i })).sort((a, b) => rank(a.m) - rank(b.m) || a.i - b.i).map((x) => x.m)
    return {
      metrics: ordered,
      dims: [...(ordered[0]?.dims ?? [])],
      sensitive: Boolean(ordered[0]?.sensitive),
    }
  })
}
